// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__vuieo","modal-show":"Modal_modal-show__xEFIZ","openModal":"Modal_openModal__xafaj","modal-bg-show":"Modal_modal-bg-show__8xHeq"};